// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-carnet{
    margin-left: var(--space-x3);
    margin-right: var(--space-x3);
    margin-bottom: var(--space-and-half);
}

.template-carnet__title{
    margin-top: var(--space-and-half);
    margin-bottom: var(--space-and-half);
}

.template-carnet__template{
    flex-direction: row !important;
}

.template-carnet__template .MuiFormControlLabel-root {
    width: 100% !important;
    justify-content: space-between !important;
}

.template-carnet__template__container{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: var(--space);
    display: flex;
    align-items: center;
    width: 45%;
    height: 50%;
}

.template-carnet__template__container__two{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: var(--space);
    display: flex;
    align-items: center;
    width: 100%;
    margin-left: 25%;
}

.template-carnet__template__container__radio.PrivateSwitchBase-root-5 {
    padding: 9px 9px 9px 50px;
}

.template-carnet__orientation .MuiFormControlLabel-root {
    width: 100%;
    justify-content: space-between;
}

.template-carnet__orientation__container{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: var(--space);
    display: flex;
    align-items: center;
    width: 45%;
    height: 50%;
}

.template-carnet__orientation__container__two{
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: var(--space);
    display: flex;
    align-items: center;
    width: 45%;
    margin-left: 10%;
    height: 50%;
}

.template-carnet__template__container__two__image{
    display: flex;
    flex-direction: column;
    width: 45%;
    align-items: center;
    gap: var(--space-half);
    margin-left: 4%;
}

.template-carnet__template__container__two__image__name{
    display: flex;
    align-items: center;
    width: 100%;
    margin-left: 25%;
}

.template-carnet__template__container__two__image__name_image {
    margin-right: var(--space);
}

.template-carnet__template__container__two__box{
    width: 100%;
}

.template-carnet__button{
    margin-top: var(--space-and-half);
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.template-carnet__delete-button {
    color: var(--primary-dark-color);
    padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/create-carnet/template-carnet/TemplateCarnetComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,UAAU;AACd","sourcesContent":[".template-carnet{\n    margin-left: var(--space-x3);\n    margin-right: var(--space-x3);\n    margin-bottom: var(--space-and-half);\n}\n\n.template-carnet__title{\n    margin-top: var(--space-and-half);\n    margin-bottom: var(--space-and-half);\n}\n\n.template-carnet__template{\n    flex-direction: row !important;\n}\n\n.template-carnet__template .MuiFormControlLabel-root {\n    width: 100% !important;\n    justify-content: space-between !important;\n}\n\n.template-carnet__template__container{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: var(--space);\n    display: flex;\n    align-items: center;\n    width: 45%;\n    height: 50%;\n}\n\n.template-carnet__template__container__two{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: var(--space);\n    display: flex;\n    align-items: center;\n    width: 100%;\n    margin-left: 25%;\n}\n\n.template-carnet__template__container__radio.PrivateSwitchBase-root-5 {\n    padding: 9px 9px 9px 50px;\n}\n\n.template-carnet__orientation .MuiFormControlLabel-root {\n    width: 100%;\n    justify-content: space-between;\n}\n\n.template-carnet__orientation__container{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: var(--space);\n    display: flex;\n    align-items: center;\n    width: 45%;\n    height: 50%;\n}\n\n.template-carnet__orientation__container__two{\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: var(--space);\n    display: flex;\n    align-items: center;\n    width: 45%;\n    margin-left: 10%;\n    height: 50%;\n}\n\n.template-carnet__template__container__two__image{\n    display: flex;\n    flex-direction: column;\n    width: 45%;\n    align-items: center;\n    gap: var(--space-half);\n    margin-left: 4%;\n}\n\n.template-carnet__template__container__two__image__name{\n    display: flex;\n    align-items: center;\n    width: 100%;\n    margin-left: 25%;\n}\n\n.template-carnet__template__container__two__image__name_image {\n    margin-right: var(--space);\n}\n\n.template-carnet__template__container__two__box{\n    width: 100%;\n}\n\n.template-carnet__button{\n    margin-top: var(--space-and-half);\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.template-carnet__delete-button {\n    color: var(--primary-dark-color);\n    padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
